export default function HealthScoreBackgroundImage() {
  return (
    <svg
      width="316"
      height="302"
      viewBox="0 0 316 302"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9552_93423)">
        <g opacity="0.1">
          <path
            d="M251.127 120.835C251.127 98.6271 253.287 62.4176 255.712 40.3488C259.184 8.79992 260.854 -21.5813 274.615 -21.4035C291.49 -21.1873 299.838 -19.6594 308.122 -17.4731C310.256 -16.9055 312.099 -15.559 313.279 -13.7047C314.459 -11.8504 314.889 -9.62592 314.482 -7.47899C294.814 101.313 307.254 170.989 296.876 296.007C295.737 309.705 272.524 302.455 258.681 303.368C256.617 303.507 254.295 303.555 252.774 302.152C251.253 300.749 251.143 298.428 251.141 296.386L251.127 120.835Z"
            fill="#F2F3F3"
          />
          <path
            d="M238.483 -17.6833C236.272 25.198 213.868 67.0666 178.16 87.5148C142.453 107.963 94.3913 104.085 64.0992 75.1677C54.7186 66.2151 47.1819 55.2891 40.8256 43.759C33.3228 30.1575 27.2911 15.2616 26.3401 -0.399627C26.1895 -2.89667 26.2178 -5.57785 27.603 -7.60886C29.3075 -10.0886 32.4954 -10.7675 35.3571 -11.2451C103.094 -22.4645 170.079 -24.0468 238.478 -17.6833"
            fill="#F2F3F3"
          />
          <path
            d="M245.029 224.606C244.402 181.646 223.566 138.581 188.65 116.179C153.733 93.7766 105.578 94.9921 74.2493 122.204C64.548 130.629 56.6157 141.127 49.8405 152.294C41.8433 165.466 35.2682 180.013 33.7401 195.606C33.4976 198.092 33.427 200.772 34.7358 202.878C36.3471 205.449 39.5066 206.304 42.3477 206.939C109.602 221.894 176.459 227.18 245.024 224.606"
            fill="#F2F3F3"
          />
          <path
            d="M168.883 300.983C146.084 300.845 108.896 298.264 86.2245 295.482C53.8139 291.499 22.6131 289.49 22.7103 274.48C22.8276 256.074 24.3445 246.977 26.5375 237.954C27.1071 235.63 28.478 233.628 30.3744 232.352C32.2707 231.077 34.5518 230.621 36.7584 231.078C148.57 253.207 102.896 240.07 231.309 252.166C245.379 253.493 238.08 278.769 239.103 293.874C239.258 296.127 239.322 298.661 237.891 300.311C236.46 301.961 234.078 302.067 231.982 302.056L168.883 300.983Z"
            fill="#F2F3F3"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_9552_93423">
          <rect width="316" height="302" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
